import { AmountsOwedIcon, AppsAndRrlsIcon, AuditLogIcon, ClientsBudgetsIcon, DailyLimitsIcon, DailyTotalsIcon, ExpensesIcon, ManualTimeEditsIcon, PaymentsIcon, ProjectsBudgetsIcon, TimeActivityIcon, TimesheetsApprovalsIcon, WeeklyLimitsIcon, WorkBreaksIcon, WorkSessionsIcon } from '../../../icons';

export const reportSections = [
  {
    title: 'Trending reports',
    items: [
      {
        url: 'time-and-activity',
        icon: <TimeActivityIcon width="100%" />,
        title: 'Time & Activity',
        description: 'View hours worked, activity %, and screenshots per project or task.',
      },
      {
        url: '/amounts-owed',
        icon: <AmountsOwedIcon width="100%" />,
        title: 'Amounts Owed',
        description: 'See how much each team member is owed based on tracked work.',
      },
      {
        url: '/daily-totals',
        icon: <DailyTotalsIcon width="100%" />,
        title: 'Daily Totals',
        description: 'Review time and activity trends for each team member.',
      },
    ],
  },
  {
    title: 'General',
    items: [
      {
        url: '/WorkSessionsReport',
        icon: <WorkSessionsIcon fontSize="large" />,
        title: 'Work Sessions',
        description: 'View start & stop times for team sessions.',
      },
      {
        url: '/apps-urls-report',
        icon: <AppsAndRrlsIcon fontSize="large" />,
        title: 'Apps & URLs',
        description: 'See apps/websites used by your team.',
      },
      {
        url: '/ManualTimeEdits',
        icon: <ManualTimeEditsIcon fontSize="large" />,
        title: 'Manual Time Edits',
        description: 'Review time entries edited manually.',
      },
      {
        url: '/timesheet-approvals-report',
        icon: <TimesheetsApprovalsIcon fontSize="large" />,
        title: 'Timesheet Approvals',
        description: 'Check the status of submitted timesheets.',
      },
      {
        url: '/ExpenseReports',
        icon: <ExpensesIcon fontSize="large" />,
        title: 'Expenses',
        description: 'Track spending to stay on top of budgets.',
      },
      {
        url: '/WorkBreakReports',
        icon: <WorkBreaksIcon fontSize="large" />,
        title: 'Work Breaks',
        description: 'View break habits across team members.',
      },
      {
        url: '/AuditLog',
        icon: <AuditLogIcon fontSize="large" />,
        title: 'Audit Log',
        description: 'Monitor logins, edits, and more.',
      },
    ],
  },
  {
    title: 'Payment',
    items: [
      {
        url: '/PaymentsReport',
        icon: <PaymentsIcon fontSize="large" />,
        title: 'Payments',
        description: 'Track how much each member has been paid.',
      },
    ],
  },
  {
    title: 'Limits',
    items: [
      {
        url: '/WeeklyLimitsReport',
        icon: <WeeklyLimitsIcon fontSize="large" />,
        title: 'Weekly Limits',
        description: 'Review weekly hour limits for team members.',
      },
      {
        url: '/DailyLimitsReport',
        icon: <DailyLimitsIcon fontSize="large" />,
        title: 'Daily Limits',
        description: 'Track daily working hour limits.',
      },
      {
        url: '/ProjectReports',
        icon: <ProjectsBudgetsIcon fontSize="large" />,
        title: 'Project Budgets',
        description: 'Track how much of project budget is used.',
      },
      {
        url: '/client-budgets-report',
        icon: <ClientsBudgetsIcon fontSize="large" />,
        title: 'Client Budgets',
        description: 'Monitor client budgets and usage.',
      },
    ],
  },
];
